import { render, staticRenderFns } from "./CreateCaptain.vue?vue&type=template&id=1d4dbb8a"
import script from "./CreateCaptain.vue?vue&type=script&lang=js"
export * from "./CreateCaptain.vue?vue&type=script&lang=js"
import style0 from "./CreateCaptain.vue?vue&type=style&index=0&id=1d4dbb8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports